module.exports = __webpack_public_path__ + "img/diferencial-title-mobile.80bce5cf.png";